// global
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Modal, Button, Table, Image } from 'semantic-ui-react';
import _ from 'lodash';
// local
// actions
import { closeModal } from 'app/redux/actions/requestDelivery/modal';
// images
import ic_warning from 'app/_assets/img/ic_warning.png';

class ConfirmModal extends Component {
    constructor(props) {
        super(props);
        const { data } = this.props.modalConfirmRequest;
        this.state = {
            data,
        };
    }
    componentWillReceiveProps(nextProps) {
        const { data } = nextProps.modalConfirmRequest;
        if (data) {
            this.setState({ data });
        }
    }

    componentWillUnmount = () => this.onClose();

    onClose = () => this.props.dispatch(closeModal());

    onClickConfirm = () => {
        this.onClose();
        const { onClickConfirm } = this.props;
        if (onClickConfirm) {
            onClickConfirm();
        }
    };

    render() {
        const { isOpened } = this.props.modalConfirmRequest;
        const { data } = this.state;
        return (
            <Modal size="small" open={isOpened} onClose={this.onClose}>
                <Modal.Content>
                    <div className="flex">
                        <Image src={ic_warning} className="icon-size flex-center" />
                        <p className="content">
                            Os pacientes abaixo possuem o número de <span className="bold">cilindros SOLICITADOS diferente do número de cilindros VAZIOS</span>.
                            Deseja continuar com as solicitações?
                        </p>
                    </div>
                    <Table>
                        <Table.Body>
                            {data &&
                                _.map(data, patient => {
                                    const key = _.uniqueId('modal_patient_');
                                    return (
                                        <Table.Row key={key}>
                                            <Table.Cell className="uppercase wrap" width={10}>
                                                {patient.name}
                                            </Table.Cell>
                                            <Table.Cell width={3}>
                                                Solicitados: <span className="bold">{patient.pendingCylinderQtdEdit}</span>
                                            </Table.Cell>
                                            <Table.Cell width={3}>
                                                Vazios: <span className="bold red">{patient.pendingCylinderQtd + patient.emptyCylinderQtd}</span>
                                            </Table.Cell>
                                        </Table.Row>
                                    );
                                })}
                        </Table.Body>
                    </Table>
                </Modal.Content>
                <Modal.Actions>
                    <Button onClick={this.onClose}>Cancelar</Button>
                    <Button onClick={this.onClickConfirm} className="highlight">
                        Continuar
                    </Button>
                </Modal.Actions>
            </Modal>
        );
    }
}

ConfirmModal.propTypes = {
    modalConfirmRequest: PropTypes.object,
    onClickConfirm: PropTypes.func,
    dispatch: PropTypes.func,
};

const mapStateToProps = state => ({
    modalConfirmRequest: state.modalConfirmRequest,
});
export default connect(mapStateToProps)(ConfirmModal);
